import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  FormLabel,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import { onSendBomToPlm } from "../../../sendBomToPlm";

export default function Modeling2DPanel() {
  const { getValues } = useFormContext();
  const [scale, setScale] = React.useState(0.07);
  const [response, setResponse] = useState({ state: "", msg: "" });
  const { id } = useParams();

  const structureDesignData = () => {
    const allData = getValues();
    const formatList = [
      { Label: "DESIGN CODE", Code: "ComboBox24" },
      { Label: "DESIGN INT. PRESSURE", Code: "txtDPressure" },
      { Label: "DESIGN EXT. PRESSURE", Code: "TextBox92" },
      { Label: "DESIGN TEMP", Code: "txtDTemp" },
      { Label: "MDMT", Code: "TextBox94" },
      { Label: "JOINT EFF. LONG.", Code: "TextBox31" },
      { Label: "JOINT EFF. CIRC.", Code: "TextBox32" },
      { Label: "RADIOGRAPHY", Code: "ComboBox20" },
      { Label: "WIND SPEED", Code: "TextBox49" },
      { Label: "WIND DESIGN CODE", Code: "TextBox50" },
      { Label: "HYDROTEST PRESSURE", Code: "TextBox67" },
      { Label: "INSULATION THK", Code: "TextBox80" },
      { Label: "PWHT", Code: "ComboBox18" },
      { Label: "U STAMP", Code: "ComboBox2" },
      { Label: "SEISMIC ZONE", Code: "TextBox_Seismic_Spec" },
    ];

    const structuredData = {};
    formatList.forEach((item) => {
      structuredData[item.Label] = allData?.[item.Code] || "";
    });

    window.electron.pv.generateDesignData(structuredData);
  };

  const onGetModelBOM = async () => {
    console.log("Fetching BOM from model...");
    const res = await onSendBomToPlm(id);
    console.log("res", res);
    if (res.state) setResponse(res);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
        p: 2,
        background: "white",
        fontSize: 10,
      }}
    >
      {/* ===================== 2D VIEW ===================== */}
      <Box
        sx={{
          width: "fit-content",
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          gap: 2,
          border: "1px solid #ccc",
          borderRadius: 2,
          alignItems: "center",
          p: 1,
        }}
      >
        {" "}
        <FormControl>
          <FormLabel sx={{ fontSize: 12, mb: 0.5 }}>Views</FormLabel>
          <RadioGroup>
            <FormControlLabel value="Top" control={<Radio />} label="Top" />
            <FormControlLabel value="Side" control={<Radio />} label="Side" />
            <FormControlLabel value="Front" control={<Radio />} label="Front" />
          </RadioGroup>

          <TextField
            type="number"
            size="small"
            placeholder="Scale"
            value={scale}
            onChange={(e) => setScale(e.target.value)}
          />
          <Button
            variant="contained"
            sx={{ my: 1 }}
            onClick={() => window.electron.pv.generate2dDrawing(scale)}
          >
            2D Drawing
          </Button>
        </FormControl>
      </Box>
      {/* ===================== TABLES & DETAILS ===================== */}
      <Box
        sx={{
          width: "fit-content",
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          border: "1px solid #ccc",
          borderRadius: 2,
          alignItems: "center",
          p: 1,
          gap: 1,
        }}
      >
        <Button fullWidth variant="outlined" onClick={structureDesignData}>
          Design Data
        </Button>

        <Button
          fullWidth
          variant="outlined"
          onClick={() => window.electron.pv.generateNotes()}
        >
          Notes
        </Button>

        <Button
          fullWidth
          variant="outlined"
          onClick={() => {
            const nozzleRows = getValues()?.DataGridView1 || [];
            const geometryRows = getValues()?.DataGridView10 || [];
            const mapped = nozzleRows.map((nozzleRow, i) => ({
              ...nozzleRow,
              ...(geometryRows[i] || {}),
              rowNo: i,
            }));
            window.electron.pv.generateNozzelesSchdule(mapped);
          }}
        >
          Nozzles Schedule
        </Button>

        <Button
          fullWidth
          variant="outlined"
          onClick={() => window.electron.pv.generatePartList()}
        >
          Parts List
        </Button>

        <Button
          fullWidth
          variant="outlined"
          onClick={() => window.electron.pv.generateRevTable()}
        >
          Revision Table
        </Button>

        <Button
          fullWidth
          variant="outlined"
          onClick={() => window.electron.pv.generateWeldDetails()}
        >
          Weld Detail
        </Button>

        <Button fullWidth variant="outlined" onClick={onGetModelBOM}>
          Send BOM to Web
        </Button>
      </Box>
    </Box>
  );
}
